import {Component, Injector, OnInit} from '@angular/core';
import {Athlete} from "../../../models/athlete";
import {AthleteService} from "../../../services/athlete/athlete.service";
import {BaseComponent} from "../../base/base.component";
import {MessageService} from "../../../services/message/message.service";
import { ConvocationService } from '../../../services/convocation/convocation.service';

@Component({
    selector: 'app-dashboard-athlete',
    templateUrl: './dashboard-athlete.component.html'
})
export class DashboardAthleteComponent extends BaseComponent implements OnInit {

    athletes: Athlete[] = [];
    loadingAthletes = true;
    numberOfNewMessages: number = 0;
    numberOfNewConvocations: number = 0;
    convocationService: ConvocationService;

    constructor(public athleteService: AthleteService, public serviceInjector: Injector, public messageService: MessageService) {
        super(serviceInjector)
        this.convocationService = serviceInjector.get(ConvocationService);
    }

    async ngOnInit() {
        await Promise.all([this.loadAthletes(), this.loadMessages(), this.loadConvocations()]);
    }

    private async loadAthletes() {
        try {
            this.athletes = (await this.athleteService.getAllAthlete({'companyId': localStorage.getItem('wisper_companyId') ?? ''})).data ?? [];
        } catch (e) {
            console.error('error loading athletes: ', e);
        } finally {
            this.loadingAthletes = false;
        }
    }

    private async loadMessages() {
        try {
            const messages = await this.messageService.getAllMessages();
            this.numberOfNewMessages = messages.data.filter((message: any) => message.seen !== 1).length;
        } catch (e) {
            console.error('error loading messages: ', e);
        }
    }

    private async loadConvocations() {
        try {
            const convocations = await this.convocationService.listConvocations();
            this.numberOfNewConvocations = convocations.data.rows.length;
        } catch (e) {
            console.error('error loading convocations: ', e);
        }
    }
}
